import React from 'react';
//Add

import { LazyLoadImage } from 'react-lazy-load-image-component';
import Blank from '../img/blank/blank-1x1.gif';

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      photoSub: props.photoSub,
    }
  }

	render() {

    return (
      <div align='center' style={{position: 'relative', }}>
            <div style={{display:'flex', flexWrap:'wrap', justifyContent:'flex-start'}} >
              {
                (this.props.photoSub) &&
                this.props.photoSub.map(
                  (value, index, array) => {
                    if (index < 3 || array.length === 4) {
                      return (
                        <div
                          style={{
                            display: 'inline-block',
                            position:'relative',
                            overflow:'hidden',
                            verticalAlign: 'bottom',
                            width:"40px", height: "40px", boxSizing:'border-box', borderRadius:'50%',
                            border: '1px solid #FFF',
                          }}
                          key={index}
                        >
                          <LazyLoadImage
                            src={ value }
                            placeholder={<img src={Blank} style={{width:"40px", height: "40px",}} alt='' />}
                            alt=''
                            style={{
                              width:'40px',
                              height:'40px',
                            }}
                          />

                          <img
                            src={Blank}
                            style={{
                              position: 'absolute',
                              left:0,
                              top:0,
                              width:'100%',
                              height:'100%',

                            }}
                            alt=''
                          />
                        </div>
                      );
                    }
                    else if (index === 3) {
                      return (
                        <div
                          style={{
                            display: 'inline-block',
                            position:'relative',
                            overflow:'hidden',
                            verticalAlign: 'bottom',
                            width:"40px", height: "40px", boxSizing:'border-box', borderRadius:'50%',
                            border: '1px solid #FFF',
                          }}
                          key={index}
                        >
                          <LazyLoadImage
                            src={ value }
                            placeholder={<img src={Blank} style={{width:"40px", height: "40px",}} alt='' />}
                            alt=''
                          />

                          <img
                            src={Blank}
                            style={{
                              position: 'absolute',
                              left:0,
                              top:0,
                              width:'100%',
                              height:'100%',
                            }}
                            alt=''
                          />
                          <div
                            style={{
                              position:'absolute',
                              top:0,
                              left:0,
                              height:"100%",
                              width: "100%",
                              display: 'flex',
                              justifyContent:'center',
                              alignItems:'center',
                              backgroundColor:'rgba(0, 0, 0, 0.5)',
                              color:"#FFF"
                            }}
                          >
                            +{this.props.photoSub.length - 3}
                          </div>
                        </div>
                      );
                    }
                    else {
                      return null;
                    }
                  }
                )
              }
            </div>
      </div>
    );
	}
}

export default Comp;
